module.exports = __webpack_public_path__ + "RMR Claim Form.pdf";